import translator from '@Components/Utilities/Translator';
import { useState, useEffect, useRef } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
const CustomWatchlistModal = loadable(() => import('@Components/Shared/Modals/CustomWatchlistModal'), true);
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import CircularProgress from '@mui/material/CircularProgress';
import { customWatchlistLimit } from '@Components/Utilities/SandhillsConstants';

const watchlistLinksCache = {};

const WatchlistsExpansion = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const currentUser = useRecoilValue(atoms.currentUser);
    const [displayModal, setDisplayModal] = useState(false);
    const [watchlistChecked, setWatchlistchecked] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (props.forceExpansion) {
            document.getElementById('focus-expansion-' + props.Id).scrollIntoView({ behavior: "smooth", block: "end" });
        }
        if (currentUser.IsAuthenticated) {
            if (!props.CustomWatchlists || props.CustomWatchlists.length > 0) {
                const cacheKey = props.Id;
                if (watchlistLinksCache[cacheKey]?.length > 0) {
                    const cached = watchlistLinksCache[cacheKey];
                    setWatchlistchecked(cached);
                    setIsLoading(false);
                    props.onWatchlistCheckedChange?.(cached.length);
                } else {
                    sandhillsRequest({
                        url: routes.GetListingWatchlistLinks,
                        method: 'post',
                        data: {
                            "listingID": props.Id
                        }
                    }).then((result) => {
                        const value = result?.length > 0 ? result : ['0'];
                        watchlistLinksCache[cacheKey] = value;
                        setWatchlistchecked(value);
                        setIsLoading(false);
                        props.onWatchlistCheckedChange?.(value.length);
                    });
                }
            } else {
                setWatchlistchecked(['0']);
                setIsLoading(false);
                props.onWatchlistCheckedChange?.(1);
            }
        }
    }, []);

    const offset = props.isDetailPage && !props.isMobilePage && ((props.CustomWatchlists?.length * 28) + 160).toString();

    const handleCheckboxClick = (value) => {
        if (watchlistChecked.includes(value.toString())) {
            const updated = watchlistChecked.filter(c => c != value.toString());
            setWatchlistchecked(updated);
            if (updated.length > 0) {
                watchlistLinksCache[props.Id] = updated;
            } else {
                delete watchlistLinksCache[props.Id];
            }
            props.onWatchlistCheckedChange?.(updated.length);
            sandhillsRequest({
                url: routes.RemoveListingFromSpecificWatchlist,
                method: 'post',
                data: {
                    "listingID": props.Id,
                    "watchlistID": value
                }
            }).then((result) => {

            });
        } else {
            const updated = [...watchlistChecked, value.toString()];
            setWatchlistchecked(updated);
            watchlistLinksCache[props.Id] = updated;
            props.onWatchlistCheckedChange?.(updated.length);
            sandhillsRequest({
                url: routes.SaveListingToSpecificWatchlist,
                method: 'post',
                data: {
                    "listingID": props.Id,
                    "watchlistID": value
                }
            }).then((result) => {

            });
        }
    }

    const handleOpenModal = (e) => {
        if (e) {
            e.preventDefault();
        }
        setDisplayModal(!displayModal);
    }


    return (
        <>
            <div className='watchlist-expansion' id={'focus-expansion-' + props.Id} style={{ 'margin-top': offset + 'px' }}>
                {isLoading ?
                    <CircularProgress sx={{ 'alignItems': 'center', 'display': 'inline-block', 'marginLeft': '80px', 'marginTop': '35px' }} /> :
                    <>
                        <div className='close' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); props.toggleWatchlistExpansion(watchlistChecked.length); } }} onClick={(e) => { props.toggleWatchlistExpansion(watchlistChecked.length) }}>{translator.translate('sandhills.closepage')} <i className='fas fa-x' /></div>
                        <div className='watchlist-epansion-content'>
                            <div className='single-watchlist'>
                                <input id='watchlist-chk' tabIndex='0' aria-labelledby='watchlist-chk-label' type='checkbox' onKeyDown={(e) => { if (e.key === 'Enter') handleCheckboxClick('0') }} onChange={(e) => { handleCheckboxClick('0') }} checked={watchlistChecked.includes('0')} />
                                <a href={props.WatchlistURL || props.WatchlistUrl} className='watchlist-checkbox' >
                                    <label htmlFor='watchlist-chk' id='watchlist-chk-label'>{translator.translate('sandhills.tradepubwebsite.mvc.watchlist')}</label>
                                    <span>{translator.translate('sandhills.mobileapps.open')}</span>
                                </a>
                            </div>
                            {props.CustomWatchlists.map((item, index) =>
                                <div className='single-watchlist'>
                                    <input id='custom-watchlist-chk' aria-labelledby='custom-watchlist-chk-label' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter') handleCheckboxClick(item.CustomWatchListID) }} type='checkbox' onChange={(e) => { handleCheckboxClick(item.CustomWatchListID) }} checked={watchlistChecked.includes(item.CustomWatchListID.toString())} />
                                    <a href={routes.WatchList + '?WLID=' + item.CustomWatchListID} className='watchlist-checkbox' >
                                        <label htmlFor='custom-watchlist-chk' id='custom-watchlist-chk-label' onClick={(e) => {}}>{item.ListName}</label>
                                        <span>Open</span></a>
                                </div>
                            )}
                            {props.CustomWatchlists.length < customWatchlistLimit &&
                                <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); handleOpenModal(); } }} onClick={handleOpenModal} className='create-watchlist'><i className='fas fa-plus' />&nbsp;&nbsp;{translator.translate('sandhills.createnewwatchlist')}</div>
                            }
                        </div>
                    </>}
            </div>
            {displayModal &&
                <CustomWatchlistModal {...props} onClose={handleOpenModal} DomNode={props.DomNode} usePortal={props.usePortal} />
            }
        </>
    );
};

export default WatchlistsExpansion;